import React, { FC } from 'react';
import { ModalTypes } from '../../../../constans/modal.constants';
import TransparentButton from '../../transparent-button/transparent-button';
import { IModalWrapperProps } from '../modal';

const ModalFooter: FC<Partial<IModalWrapperProps>> = (props: Partial<IModalWrapperProps>) => {
  const modalFooterClassName = `modal-footer ${props.modalType}`;
  const shouldShowCancelButton = props.modalType === ModalTypes.CONFIRMATION;

  return (
    <div className={modalFooterClassName}>
      {shouldShowCancelButton &&
        <TransparentButton name='cancel' onClick={props.cancelAction}>{props.cancelButtonText || 'Cancel'}</TransparentButton>
      }
      <TransparentButton name='done' onClick={props.doneAction || props.cancelAction}>{props.doneButtonText || 'Ok'}</TransparentButton>
    </div>
  );
};

export default ModalFooter;
